import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLocalOfferSvg } from "./IconLocalOfferSvg.mjs";
const IconLocalOffer = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLocalOfferSvg, ...iconProps });
};
export {
  IconLocalOffer
};
